// Static enums for MzansiFootball Talent Connect
export const PROVINCES = [
  'Gauteng', 'Western Cape', 'KwaZulu-Natal', 'Eastern Cape', 'Free State',
  'Limpopo', 'Mpumalanga', 'North West', 'Northern Cape'
];

export const POSITIONS = [
  'Goalkeeper', 'Right Back', 'Left Back', 'Centre Back', 'Defensive Midfielder',
  'Central Midfielder', 'Attacking Midfielder', 'Right Winger', 'Left Winger',
  'Striker', 'Second Striker'
];
